const CompanyFactory = require('./company').factory;

function DesygnerCompanyFactory () {}
DesygnerCompanyFactory.prototype = new CompanyFactory();
DesygnerCompanyFactory.prototype.constructor = DesygnerCompanyFactory;

DesygnerCompanyFactory.prototype.initialize = function () {
  return this.initCache().then(_.bind(this.initCredentials, this));
};

DesygnerCompanyFactory.prototype.getResourceUrl = function (route) {
  let endpoint = 'brand/companies/desygner';

  for (let i = 0; i < route.length; i += 2) {
    endpoint += route[i + 1]
      ? '/' + route[i] + '/' + route[i + 1]
      : '/' + route[i];
  }

  return this.getEndpointUrl(endpoint);
};

module.exports = new DesygnerCompanyFactory();
